export default __webpack_public_path__ + "static/media/Boton_2.7e717b86.png";